const HOME_TAB_NAME = '首页'

function normalizeTabs (tabs) {
  const list = Array.isArray(tabs) ? tabs.filter(Boolean) : []
  if (!list.length) return []

  let homeTab = null
  const seen = {}
  const otherTabs = []

  for (const item of list) {
    if (!item || !item.name) continue
    if (item.name === HOME_TAB_NAME) {
      if (!homeTab) {
        homeTab = Object.assign({}, item, { name: HOME_TAB_NAME, title: HOME_TAB_NAME })
      }
      continue
    }
    if (seen[item.name]) continue
    seen[item.name] = true
    otherTabs.push(item)
  }

  if (!homeTab) {
    homeTab = { name: HOME_TAB_NAME, title: HOME_TAB_NAME, keepAlive: 'Index' }
  }

  return [homeTab].concat(otherTabs)
}

export default {
  state: {
    // 标签列表
    TabList: [],
    // 当前活动标签
    activeTab: '',
    dropdownMenu: false,
    dropdownTissue: false,
    TissueList:[],
    menuNameActive:"",
  },
  mutations: {
    updateTabList (state, tabs) {
      // const hasObj = {}
      // const arr1 = tabs.reduce((total, next) => {
      //     const filterKey = next.name + next.keepAlive
      //     hasObj[filterKey] ? '' : hasObj[filterKey] = true && total.push(next)
      //     return total
      // }, [])
      // console.log(state, arr1,state.activeTab,localStorage.menuNameActive)
      state.TabList = normalizeTabs(tabs)
    },
    updateActiveTab (state, name) {
      state.activeTab = name
    },
    dropdownMenu (state, flag) {
      state.dropdownMenu = flag
    },
    dropdownTissue (state, flag) {
      state.dropdownTissue = flag
    },
    TissueList (state, tabs) {
      state.TissueList = tabs
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tabs.js